import { action, makeObservable, observable, onBecomeObserved } from "mobx"

import { catchErrors, topupsApi } from "@src/shared/api"
import { TopupBankAccountResponse } from "@src/shared/api/generated"
import { loading } from "@src/shared/classes/utils/loading"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"

type FiatTopUpState = {
  accounts: Required<TopupBankAccountResponse>[]
}

class FiatTopUp extends loading(["fetch"]) {
  state: FiatTopUpState = {
    accounts: [],
  }

  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      state: observable.deep,
    })

    const kill = onBecomeObserved(this, "state", () => {
      kill()

      return this.fetch()
    })
  }

  accountByCurrency(currency: string): TopupBankAccountResponse | undefined {
    if (this.accountsCurrency.includes(currency)) {
      return this.state.accounts.find(
        (account) => account.currency === currency,
      )
    }

    return undefined
  }

  async fetch() {
    try {
      const { data: { data } = {} } = await topupsApi.getTopupBankAccounts()

      if (data?.length) {
        this.state.accounts = data as Required<TopupBankAccountResponse>[]
      }
    } catch (e: any) {
      catchErrors(e)
    }
  }

  get accountsCurrency() {
    return this.state.accounts.map((account) => account.currency)
  }
}

export const GlobalFiatTopUp = wrapSingleton<FiatTopUp>(FiatTopUp)
